import React, { useEffect, useState } from 'react';
import { Loader, Progress, Container, Header } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { EPICS_PATH_CONTINUE } from 'volto-epics-addon/constants';
import { TASK_UPLOAD_WAITFORJOBS_VIEW } from 'volto-base-addon/constants';
import { useTaskPoll } from 'volto-epics-addon/helpers';
import UploadStepsContainer from './UploadStepsContainer';
import errorIcon from './icons/error.svg';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import config from '@plone/volto/registry';
import { useIntl, defineMessages, FormattedMessage } from 'react-intl';

const messages = defineMessages({
  waitingInitialProcessing: {
    id: 'waitingInitialProcessing',
    defaultMessage:
      'Waiting for the initial processing of the uploaded file to finish.',
  },
  transcodingPreview: {
    id: 'transcodingPreview',
    defaultMessage: 'Transcoding a preview profile..',
  },
  loading: {
    id: 'loading',
    defaultMessage: 'Loading..',
  },
  unexpectedError: {
    id: 'unexpectedError',
    defaultMessage: 'Unexpected Error',
  },
  errorProcessingFileBody: {
    id: 'errorProcessingFileBody',
    defaultMessage:
      'Unfortunately, we encountered an error while processing your file. For more information please read {helplink}',
  },
  helpLinkText: {
    id: 'helpLinkText',
    defaultMessage: 'help',
  },
  mustLoginFirst: {
    id: 'mustLoginFirst',
    defaultMessage: 'You must log in first.',
  },
});

const Page = () => {
  const history = useHistory();
  const intl = useIntl();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [transcodingProgress, setTranscodingProgress] = useState(null);
  const [errorCode, setErrorCode] = useState(undefined);
  const task = useTaskPoll(1000, TASK_UPLOAD_WAITFORJOBS_VIEW);
  const token = useSelector((state) => state.userSession.token);
  const helpLink = `${config.settings.publicURL}/help`;

  useEffect(() => {
    setIsAuthenticated(!!token);
    setIsVisible(true);
  }, [token]);

  useEffect(() => {
    var duration = parseFloat(task?.variables?.duration);
    var progress = task?.variables?.transcodingProgress;
    setErrorCode(task?.variables?.errorCode);
    // Select correct transcoding to follow..
    var currentTime;
    if (progress && '360p' in progress) {
      currentTime = parseFloat(progress['360p']['current_time']);
    } else if (progress && 'Audio' in progress) {
      currentTime = parseFloat(progress['Audio']['current_time']);
    }

    // Update progress bar
    if (duration && currentTime) {
      var percentage = parseInt(
        Math.min(100, Math.max(0, currentTime / duration)) * 100,
      );
      setTranscodingProgress(percentage);
    }

    if (task?.completed === true) {
      history.push(EPICS_PATH_CONTINUE);
    }
  }, [task, history]);

  return isVisible ? (
    isAuthenticated ? (
      <Container className="waitforjobs-view-container">
        <UploadStepsContainer currentStep={2} totalSteps={4} />
        {errorCode === undefined ? (
          <>
            <Header>
              {intl.formatMessage(messages.waitingInitialProcessing)}
            </Header>
            {transcodingProgress && transcodingProgress < 100 ? (
              <>
                <p> {intl.formatMessage(messages.transcodingPreview)} </p>
                <Progress percent={transcodingProgress} indicating />
              </>
            ) : (
              <>
                <p> {intl.formatMessage(messages.loading)} </p>
                <Loader active inline />
              </>
            )}
          </>
        ) : (
          <div style={{}}>
            <Header
              style={{
                justifyContent: 'center',
                marginTop: '100px',
              }}
            >
              <Icon name={errorIcon} size="48px" style={{ width: '100%' }} />
              <p>{intl.formatMessage(messages.unexpectedError)}</p>
            </Header>
            <p style={{ textAlign: 'center' }}>
              <FormattedMessage
                {...messages.errorProcessingFileBody}
                values={{
                  helplink: (
                    <a href={helpLink} target="_blank" rel="noreferrer">
                      {intl.formatMessage(messages.helpLinkText)}
                    </a>
                  ),
                }}
              />
            </p>
          </div>
        )}
      </Container>
    ) : (
      <Container className="waitforjobs-view-container">
        <Header className="ui header">
          {' '}
          {intl.formatMessage(messages.mustLoginFirst)}{' '}
        </Header>
      </Container>
    )
  ) : (
    <Container className="waitforjobs-view-container"></Container>
  );
};

export default Page;
